import React from "react";
import { Routes, Route } from "react-router-dom";
import SignUp from "./Auth/SignUp/SignUp";
import SUOwner from "./Auth/SignUp/SUOwner/SUOwner";
import SUService from "./Auth/SignUp/SUService/SUService";
import SignIn from "./Auth/SignIn/SignIn";
import SIOwner from "./Auth/SignIn/SIOwner";
import Home from "./Home/Home";
import Owner from "./Users/Owner/Owner";
import Visitor from "./Users/Visitor/Visitor";
import Service from "./Users/Service/Service";
import Income from "./Users/Visitor/Bonuses/Income";
import Outcome from "./Users/Visitor/Bonuses/Outcome";
import MainLayout from "./layouts/MainLayout";
import NFLayout from "./layouts/NFLayouts";
import Notfound from "./notFound/Notfound";
import PrivateLayout from "./layouts/PrivateLayout";
// eslint-disable-next-line no-unused-vars
import appStyle from "./scss/app.scss";

function App() {
  return (
    <>
      <Routes>
        <Route element={<MainLayout />}>
          <Route path="/" element={<Home />} />
          <Route path="/signin" element={<SignIn />} />
          <Route path="/signin-owner" element={<SIOwner />} />
          <Route path="/signup" element={<SignUp />} />
          <Route path="/signup-owner" element={<SUOwner />}/>
          <Route path="/signup-service" element={<SUService />} />
        </Route>
        <Route element={<PrivateLayout />}>
          <Route path="/owner" element={<Owner />} />
          <Route path="/user" element={<Visitor />} />
          <Route path="/service" element={<Service />} />
        </Route>
        <Route element={<NFLayout />}>
          <Route path="/income" element={<Income />} />
          <Route path="/outcome" element={<Outcome />} />
          <Route path="*" element={<Notfound />}/>
        </Route>
      </Routes>
    </>
  );
}

export default App;